<template>
    <datepicker class="custom-date-picker" :open-date="openDate" :disabledDates="disabledDates" :language="it" :placeholder="placeholder" :value="value" @input="onInput" :format="dateFormatter"/>
</template>

<script>
import { it } from 'vuejs-datepicker/dist/locale'

export default {
  name: 'CustomDatePicker',
  props: {
    value: {
      type: Date
    },
    placeholder: {
      type: String,
      default: 'gg/mm/aaaa'
    },
    disabledDates: {
      type: Object,
      default: function () {
        return {
          to: new Date()
        }
      }
    },
    openDate: {
      type: Date,
      default: null
    }
  },
  data: function () {
    return {
      it: it
    }
  },
  computed: {
    classes: function () {
      return this.opened ? 'custom-date-picker' : 'custom-date-picker'
    }
  },
  methods: {
    dateFormatter: function (date) {
      return this.$moment(date).format('DD/MM/YYYY')
    },
    onInput: function (date) {
      this.$emit('input', date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/CustomDatePicker.vue